import React, { useCallback, useContext } from 'react';
import { PlaybackInformationContext } from '../../../contexts/PlaybackInformationContext';

export const PlaybackInformationAdPlayback: React.FC = () => {
	const { player, position } = useContext(PlaybackInformationContext);

	const { currentAdBreak } = player.player.ads;

	let skipOffset = 10;
	try {
		skipOffset = currentAdBreak.ads[0].skipOffset; // eslint-disable-line prefer-destructuring
	} catch (error) {}

	const duration = Math.min(skipOffset, currentAdBreak.maxDuration);
	const remaining = duration - position;
	const remainingRounded = Math.floor(remaining);

	const progress = Math.max(0, remaining / duration);
	const size = 80;
	const radius = size / 2;
	const strokeWidth = 2;
	const circumference = radius * 2 * Math.PI;

	const skip = useCallback(() => {
		player.skipAd();
	}, [player]);

	return (
		<div className={'playback-information playback-information-ad'}>
			<div role={'presentation'} className={'playback-information-ad-skip'} onClick={skip}>
				<svg width={size} height={size}>
					<circle className={'playback-information-ad-skip-circle-background'} r={radius - 1.5 * strokeWidth} cx={radius} cy={radius} />
					<circle
						className={'playback-information-ad-skip-circle'}
						fill={'transparent'}
						stroke={'white'}
						strokeWidth={strokeWidth}
						style={{
							strokeDasharray: `${circumference},${circumference}`,
							strokeDashoffset: circumference * progress,
						}}
						r={radius - 2 * strokeWidth}
						cx={radius}
						cy={radius}
					/>
				</svg>
				<div className={'playback-information-ad-skip-progress'}>
					{remaining >= 0 && <span>{remainingRounded}</span>}
					{remaining < 0 && (
						<svg xmlns={'http://www.w3.org/2000/svg'} viewBox={'0 0 448 512'}>
							<path d={'M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z'} /> {/* eslint-disable-line */}
						</svg>
					)}
				</div>
			</div>
		</div>
	);
};
